import styled from 'styled-components';

export const SWrapper = styled.div`
  display: flex;
  gap: 6px;
`;
